import { useEffect, useState } from 'react';
import { createBlobObj } from '../../helper';

export const useGeneratePdfContent = (generatePdfApiRes: any) => {
  const [downloading, setIsDownloading] = useState<boolean>(false);
  const [copied, setCopied] = useState<boolean>(false);
  const [blobObj, setBlobObj] = useState<Blob | null>(null);

  const handleDownloadPdf = async (
    pdfApiUrl: string,
    filename = 'product_catalogue.pdf'
  ) => {
    setIsDownloading(true);

    try {
      // Fetch the PDF from API
      const response = await fetch(pdfApiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      // Create a temporary URL for the blob
      const tempUrl = URL.createObjectURL(blob);

      // Create a temporary download link
      const downloadLink = document.createElement('a');
      downloadLink.href = tempUrl;
      downloadLink.download = filename;
      downloadLink.style.display = 'none';

      // Append to body, click, and remove
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Clean up the temporary URL
      URL.revokeObjectURL(tempUrl);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF.');
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    if (generatePdfApiRes?.isSuccess && generatePdfApiRes?.data) {
      createBlobObj(generatePdfApiRes?.data)
        ?.then((res) => {
          res && setBlobObj(res);
        })
        .catch((err) => {
          console.error('Error creating blob object:', err);
        });
    }
  }, [generatePdfApiRes]);

  return {
    downloading,
    copied,
    setCopied,
    handleDownloadPdf,
    blobObj,
  };
};
